<template>
  <div>
    <h1 class="h3">Gear up!</h1>
    <p class="label m-10"><sup>*</sup> required</p>
    <p>Exclusive merch for members only</p>
    <b-row>
      <b-col md="3">
        <ValidationProvider rules="required" name="radios-btn-shirt" v-slot="{ errors }" slim>
          <b-form-group label="Shirt size*" class="radio-focus-group">
            <b-form-radio-group
              :state="errors[0] ? false : null"
              :options="options"
              v-model="selected_shirt"
              id="btn-radios-shirt"
              name="radios-btn-shirt"
              buttons
              v-remove-aria-required
            >
            </b-form-radio-group>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="radios-btn-hat" v-slot="{ errors }" slim>
          <b-form-group class="GearInfo__hat-sizes radio-focus-group" label="Hat size*" >
            <b-form-radio-group
              :state="errors[0] ? false : null"
              :options="options.filter((option) => option.value !== '3XL' && option.value !== '2XL')"
              id="btn-radios-hat"
              v-model="selected_hat"
              name="radios-btn-hat"
              buttons
              v-remove-aria-required
            ></b-form-radio-group>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col md="3">
        <ValidationProvider rules="required" name="radios-btn-hat" v-slot="{ errors }" slim>
         <b-form-group label="Jacket size*" class="radio-focus-group">
            <b-form-radio-group
              :state="errors[0] ? false : null"
              :options="options"
              id="btn-radios-jacket"
              v-model="selected_jacket"
              name="radios-btn-jacket"
              buttons
              v-remove-aria-required
            ></b-form-radio-group>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'GearInfo',
  data() {
    return {
      options: [
        { text: 'XS', value: 'XS' },
        { text: 'S', value: 'S' },
        { text: 'M', value: 'M' },
        { text: 'L', value: 'L' },
        { text: 'XL', value: 'XL' },
        { text: 'XXL', value: '2XL' },
        { text: 'XXXL', value: '3XL' },
      ],
    };
  },
  watch: {
    selected_shirt(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.validateStep();
      }
    },
    selected_hat(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.validateStep();
      }
    },
    selected_jacket(newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        this.validateStep();
      }
    },
  },
  computed: {
    selected_shirt: {
      get() {
        return this.$store.state.ShirtSize;
      },
      set(value) {
        this.$store.dispatch('shirtSize', value);
      },
    },
    selected_hat: {
      get() {
        return this.$store.state.HatSize;
      },
      set(value) {
        this.$store.dispatch('hatSize', value);
      },
    },
    selected_jacket: {
      get() {
        return this.$store.state.JacketSize;
      },
      set(value) {
        this.$store.dispatch('jacketSize', value);
      },
    },
  },
  methods: {
    validateStep() {
      this.$nextTick(() => this.$emit('onValidate', null));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_breakpoints.scss';
@import '@/assets/styles/components/_button.scss';
.GearInfo {
  &__hat-sizes {
    padding-left: 20px;

    @include media-breakpoint-down(md) {
      padding-left: 0;
    }
  }
}
h1 {
  margin-bottom: 16px;
}

p {
  margin-bottom: 20px;
}
.m-10 {
  margin-bottom: 10px;
}

.btn-secondary {
  display: none;
  &:focus {
		outline: none;
	}
  &:focus {
			box-shadow: 0 0 0 .2em #fff,0 0 0 .4em #000;
		}
}
</style>
